
define('ldsh!modules/page_listing/templates/search_layout', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<form>\n  <div class="ed-search-box ed-form-group">\n    <button class="ed-btn ed-search-btn js-button-search">\n      <i class="ri-search-line"></i>\n      <span\n        class="txt"\n        data-i18n="pageListing.search.search"\n      >Buscar</span>\n    </button>\n    <input\n      class="ed-input-search ed-form-control js-search-text e50"\n      type="text"\n      autosave="unique"\n      autocomplete="off"\n      name="s"\n      results="5"\n      data-i18n="[placeholder]pageListing.search.inputPlaceholder"\n    />\n    <div class="js-tag-list hidden"></div>\n  </div>\n  <div class="js-tag-cloud ed-tag-cloud-container"></div>\n</form>';

}
return __p
};});

